import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './Modal.module.css';

const ModalContext = React.createContext();

export const ModalProvider = ({ children }) => {
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [modalHeader, setHeaderContent] = React.useState('Ошибка');
  const [modalContent, setModalContent] = React.useState('Данное содержимое недоступно');

  const openModal = (header, content) => {
    setHeaderContent(header);
    setModalContent(() => content);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  React.useEffect(() => {
    const body = document.querySelector('body');
    if (isModalOpen) {
      body.classList.add('modal-open');
    } else {
      body.classList.remove('modal-open');
    }
  }, [isModalOpen]);

  // Анимация для модального окна
  const modalVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
  };

  return (
    <ModalContext.Provider value={{ isModalOpen, openModal, closeModal, modalHeader, modalContent }}>
      {children}

      <AnimatePresence>
        {isModalOpen && (
          <motion.div
            className={styles.underlining}
            onClick={closeModal}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div
              className={styles.lining}
              onClick={(e) => e.stopPropagation()}
              variants={modalVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ duration: 0.2 }}
            >
              <div className={styles.liningheader}>
                <div>
                  <h1>{modalHeader}</h1>
                  <button className={styles.closeButton} onClick={closeModal}>
                    <svg viewBox="0 0 24 24" fill="none">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.68342 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                        fill="#000000"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div className={styles.liningmain}>
                <div>
                  {modalContent && typeof modalContent === 'function' ? modalContent() : modalContent}
                  <a
                    className="button black maxWidth"
                    style={{ marginTop: '25px' }}
                    onClick={() => closeModal()}
                  >
                    Понятно
                  </a>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </ModalContext.Provider>
  );
};

export const useModal = () => React.useContext(ModalContext);
